var render = function render(){var _vm=this,_c=_vm._self._c;return _c('new-layout',{attrs:{"backgroundImage":_vm.backgroundImage,"showLogo":true,"backgroundImage2x":_vm.backgroundImage2x}},[_c('error-card',{staticClass:"error-card"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }